import React from "react";
import ProfileNavbar from "../navbar/ProfileNavbar";
import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaPhoneAlt,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const ProfileHeader = () => {
  return (
    <div id="header">
      <div className="p-1">
        <div className="d-flex justify-content-between px-md-5 mx-6">
          <div className="d-flex gap-4 ">
            <a href="https://www.facebook.com/kibisports" target="_blank">
              <FaFacebook color="#2e2e2e" size={22} />
            </a>

            <a
              href="https://in.linkedin.com/company/kibi-sports"
              target="_blank"
            >
              <FaLinkedin color="#2e2e2e" size={22} />
            </a>

            <a href="https://www.youtube.com/c/KIBISPORTS" target="_blank">
              <FaYoutube color="#2e2e2e" size={22} />
            </a>
          </div>
          <div className="text-white">
            <ul className="d-md-flex gap-3">
              <li className="d-flex gap-2">
                <FaPhoneAlt color="#2e2e2e" size={20} />
                <p style={{ color: "#2e2e2e" }}>+91 1234567890</p>
              </li>
              <li className="d-flex gap-2">
                <MdEmail color="#2e2e2e" size={20} />
                <p style={{ color: "#2e2e2e" }}>testing@gmail.com</p>
              </li>
            </ul>
          </div>
        </div>
        <ProfileNavbar />

        {/* <div className="px-md-5 py-5 mx-6">
          <h1 className="text-white headerText">
            <span className="fw-bold">LOREM IPSUM IS</span>
            <br /> simply dummy text
          </h1>
          <p className="mt-4 text-white normalText">
            Lorem Ipsum is simply dummy text of the printing and <br />{" "}
            typesetting industry
          </p>
          <button className="arrowBtn d-flex gap-2 px-4 py-1 align-items-center">
            <p className="ms-2 me-3 mt-3">Lorem Ipsum</p>
            <FaArrowAltCircleRight size={20} className="ms-1 me-2" />
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ProfileHeader;
